import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { Card, message } from 'antd';

import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { queryDeleteSeal, querySaveSeal, querySealWorkflow } from '@api/administrative/seal';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.sealWorkflow();
  }

  /**
   * 提交用章
   */
  handSubmit = item => {
    this.saveSeal(item);
  };

  sealWorkflow = params => {
    const { instance } = this.state;
    querySealWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveSeal = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveSeal(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
      }
    });
  };

  deleteSeal = () => {
    queryDeleteSeal({
      uuid: this.props.data.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={dataInfo}
          handSubmit={this.handSubmit}
          handleDelete={this.deleteSeal}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/administrative/seal/PageEdit.js